import { ArrowLeft } from "lucide-react";
import React, { useState } from "react";
import {
  ActionIcon,
  Button,
  Drawer,
  Group,
  ScrollArea,
  Space,
  Text,
} from "@mantine/core";
import SurveyTable from "../components/SurveyTable";
import PageHeading from "../../../themes/components/PageHeading";
import SurveyForm from "../components/SurveyForm";
import PermissionProtectedComponent from "../../../common/uac/PermissionProtectedComponent";
import { PERMISSION_ADD_FORM } from "../../../utils/UserAccessControlUtils";
import PageContainer from "../../../themes/components/PageContainer";
import SurveyList from "../services/model/SurveyList";
import CloseMultipleSurveyButton from "../elements/CloseMultipleSurveyButton";
import NotFound from "../../../common/pages/NotFound";
import { AccessPermissionContext } from "../../../providers/AccessPermissionsProvider";

const SurveyDirectoryPage: React.FC = () => {
  const [opened, setOpened] = useState(false);
  const [selection, setSelection] = useState<SurveyList[]>([]);

  const { hasPermissions } = React.useContext(AccessPermissionContext);

  if (!hasPermissions) {
    return <NotFound />;
  }

  return (
    <PageContainer>
      <Drawer
        opened={opened}
        size="full"
        onClose={() => setOpened(false)}
        styles={{
          header: {
            backgroundColor: "#ffffff",
          },
          title: { width: "100%" },
          drawer: {
            backgroundColor: "#f7f7f8",
          },
        }}
        title={
          <Group
            position="apart"
            spacing="xl"
            style={{
              width: "100%",
            }}
          >
            <Group spacing="xl">
              <ActionIcon onClick={() => setOpened(false)}>
                <ArrowLeft />
              </ActionIcon>

              <Text className="Heading">Create Survey</Text>
            </Group>
            <Group spacing="xl">
              <Text
                style={{
                  flexGrow: 0,
                  fontSize: "18px",
                  fontWeight: 500,
                  fontStretch: "normal",
                  fontStyle: "normal",
                  lineHeight: "normal",
                  letterSpacing: "0.16px",
                  textAlign: "left",
                }}
              >
                Survey Details
              </Text>

              <Space w="lg" />
              <Space w="lg" />
              {/* <Space w="lg" /> */}
              <Space w="md" />
              <Space w="sm" />
            </Group>
          </Group>
        }
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <ScrollArea
          style={{
            backgroundColor: "#f7f7f8",
            height: "800px",
          }}
        >
          <SurveyForm onSuccess={() => setOpened(false)} />
        </ScrollArea>
      </Drawer>
      <PageHeading title="Surveys">
        {selection.length > 0 && (
          <CloseMultipleSurveyButton surveys={selection} />
        )}
        <PermissionProtectedComponent
          requiredViewPermissions={[PERMISSION_ADD_FORM]}
        >
          <Button
            variant="filled"
            type="button"
            color="jem-theme"
            onClick={() => setOpened(true)}
          >
            Create Survey
          </Button>
        </PermissionProtectedComponent>
      </PageHeading>

      <Space h="xl" />
      <SurveyTable onSelection={setSelection} selection={selection} />
    </PageContainer>
  );
};

export default SurveyDirectoryPage;
